import { StyledFormGroup } from "../styled-form-group";
import { InputGroup } from "@blueprintjs/core";
import { onChangeFactory } from "./helpers";
import React from "react";
import "styled-components/macro";

export function FlightNumberInput({
  formState,
  formActions,
  activeField,
  setActiveField,
  data_testid,
  helperText,
  label,
  isVisible = true,
}) {
  return !isVisible ? null : (
    <StyledFormGroup
      helperText={helperText}
      label={label}
      labelFor="flightNumber"
      activeField={activeField}
    >
      <InputGroup
        data-testid={data_testid}
        name="flightNumber"
        value={formState.flightNumber}
        onChange={onChangeFactory(formActions.setFlightNumber)}
        leftIcon="airplane"
        type="text"
        large
        onFocus={() => setActiveField("flightNumber")}
      />
    </StyledFormGroup>
  );
}
